import Lottie from 'lottie-react';
import { ILoading } from './Loading.interface';
import LoadingAnimation from "./../../shared/assets/imgs/loading.json";

function Loading(props: ILoading) {
    return <dialog className="loading" open>
        <Lottie animationData={LoadingAnimation} loop={true} />
    </dialog>;
}

export default Loading;
